<template>
  <b-modal
    :id="`FlagMissingClassifiers-${item.uuid}`"
    title="Brand Safety Classifiers"
    size="lg"
    cancel-variant="tertiary"
    ok-title="Send"
    @ok="sendClassifiers"
  >
    <b-row>
      <b-col
        v-for="classifier in classifiers"
        :key="classifier"
        class="col-lg-3 classifier"
      >
        <b-form-checkbox
          :id="classifier"
          v-model="selectedClassifiers"
          :value="classifier"
          @change="isBrandSafe = false"
        >
          <span>{{ classifier }}</span>
        </b-form-checkbox>
      </b-col>
    </b-row>
    <b-row class="brand-safe-classifier-row pl-3">
      <b-col class="col-lg-12 brand-safe-classifier-column">
        <b-form-checkbox
          id="brand-safe"
          v-model="isBrandSafe"
          @change="toggleBrandSafeBox"
        >
          <span>Brand Safe</span>
        </b-form-checkbox>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>

import { mapActions } from 'vuex';
import * as campaignMatchesTypes from '@/modules/campaignMatches/store/types';

export default {
  name: 'BrandsafetyClassifiersModal',
  props: {
    classifiers: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBrandSafe: false,
      selectedClassifiers: [],
    };
  },
  methods: {
    ...mapActions('campaignMatches', [
      campaignMatchesTypes.UPDATE_BRANDSAFETY_CLASSIFIERS,
    ]),
    sendClassifiers() {
      if (this.selectedClassifiers.length > 0 || this.isBrandSafe) {
        const labels = this.selectedClassifiers.length > 0 ? this.selectedClassifiers : ['NOTBLACKLISTED'];
        this.$emit('updateClassifiers', { item: this.item, labels });
      }
    },
    toggleBrandSafeBox(isToggled) {
      if (isToggled) {
        this.selectedClassifiers = [];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.classifier {
  height: 45px;
  line-height: 1;
}
.brand-safe-classifier-row {
  width: 35%;
  height: 45px;
  display: flex;
  align-items: center;
  background-color: $success-light;
}
</style>
